export default "__VITE_ASSET__CnSQir4g__"